/**
 * Scripts that run on the modules page
 */
(
  /**
   * Self-invoking function to run our page scripts
   *
   * @param {Window} window
   * @param {Document} document
   * @param {jQuery} $
   * @param {Function} _
   * @param {bootstrap} bs
   * @param {undefined} undefined
   *
   * @return {void}
   */
  function (window, document, $, _, bs, undefined) {
    /**
     * @callback
     * @param {Event} e
     * @return {void}
     */
    function setIFrameSrc (e) {
      /** @type {HTMLDivElement|null} */
      const modal = _.get(e, 'target');

      if (modal instanceof HTMLDivElement) {
        /** @type {HTMLIFrameElement|null} */
        const iFrame = modal.querySelector(':scope iframe');

        if (iFrame instanceof HTMLIFrameElement) {
          /** @type {string} */
          const storyLineSrc = _.get(iFrame, 'dataset.src', '');

          if (!_.isEmpty(storyLineSrc)) {
            _.set(iFrame, 'src', storyLineSrc);
          }
        }
      }
    }

    /**
     * @callback
     * @param {Event} e
     * @return {void}
     */
    function clearIFrameSrc (e) {
      /** @type {HTMLDivElement|null} */
      const modal = _.get(e, 'target');

      if (modal instanceof HTMLDivElement) {
        /** @type {HTMLIFrameElement|null} */
        const iFrame = modal.querySelector(':scope iframe');

        if (iFrame instanceof HTMLIFrameElement) {
          _.set(iFrame, 'src', '');
        }
      }
    }

    /**
     * @callback
     * @param {HTMLDivElement} modal
     */
    function addModalEventListeners (modal) {
      modal.addEventListener('show.bs.modal', setIFrameSrc);
      modal.addEventListener('hidden.bs.modal', clearIFrameSrc);
    }

    /**
     * Runs when the DOM is loaded, so we can manipulate the page contents
     *
     * @callback
     * @return {void}
     */
    function sharpeningsReady () {
      const modals = document.querySelectorAll('div.modal.educational-sharpenings-item-modal'),
        Modal = _.get(bs, 'Modal', null);

      function isModal (modal) {
        if (!_.isNull(Modal)) {
          return modal instanceof Modal;
        }

        return false;
      }

      modals.forEach(addModalEventListeners);
    }

    // Set up interactions when the DOM is ready
    $(document).ready(sharpeningsReady);
  }
)(window, document, window.jQuery, window.lodash, window.bootstrap);
